import type { TranslateDictionary } from './en.js';

export const Ko: TranslateDictionary = {
  'Start airplay': 'AirPlay 시작',
  'Stop airplay': 'AirPlay 중지',
  Audio: '오디오',
  Captions: '자막',
  'Enable captions': '자막 사용',
  'Disable captions': '자막 사용 안함',
  'Start casting': '캐스트 시작',
  'Stop casting': '캐스트 중지',
  'Casting to {device}': '{device}(으)로 전송 중',
  'Enter fullscreen mode': '전체 화면',
  'Exit fullscreen mode': '전체 화면 종료',
  Mute: '음소거',
  Unmute: '음소거 해제',
  'Enter picture in picture mode': '화면 속 화면 모드 시작',
  'Exit picture in picture mode': '화면 속 화면 모드 종료',
  Play: '재생',
  Pause: '일시중지',
  'Playback rate': '재생 속도',
  'Playback rate {playbackRate}': '재생 속도 {playbackRate}',
  Quality: '품질',
  'Seek backward': '뒤로',
  'Seek forward': '앞으로',
  Settings: '설정',
  Auto: '자동',
  'audio player': '오디오 플레이어',
  'video player': '비디오 플레이어',
  volume: '볼륨',
  seek: '검색',
  'closed captions': '자막',
  'current playback rate': '현재 재생 속도',
  'playback time': '재생 시간',
  'media loading': '미디어 로딩 중',
  settings: '설정',
  'audio tracks': '오디오 트랙',
  quality: '품질',
  play: '재생',
  pause: '일시중지',
  mute: '음소거',
  unmute: '음소거 해제',
  'chapter: {chapterName}': '챕터: {chapterName}',
  live: '라이브',
  Off: '끄기',
  'start airplay': 'AirPlay 시작',
  'stop airplay': 'AirPlay 중지',
  'start casting': '캐스트 시작',
  'stop casting': '캐스트 중지',
  'enter fullscreen mode': '전체 화면',
  'exit fullscreen mode': '전체 화면 종료',
  'enter picture in picture mode': '화면 속 화면 모드 시작',
  'exit picture in picture mode': '화면 속 화면 모드 종료',
  'seek to live': '라이브로 이동',
  'playing live': '라이브 재생 중',
  'seek back {seekOffset} seconds': '뒤로 {seekOffset}초',
  'seek forward {seekOffset} seconds': '앞으로 {seekOffset}초',
  'Network Error': '네트워크 오류',
  'Decode Error': '디코드 오류',
  'Source Not Supported': '소스가 지원되지 않음',
  'Encryption Error': '암호화 오류',
  'A network error caused the media download to fail.':
    '네트워크 오류로 인해 미디어 다운로드에 실패했습니다.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    '미디어 오류로 인해 재생이 중단되었습니다. 미디어가 손상되었거나 브라우저가 이 형식을 지원하지 않습니다.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    '지원되지 않는 오류가 발생했습니다. 서버 또는 네트워크가 실패했거나 브라우저가 이 형식을 지원하지 않습니다.',
  'The media is encrypted and there are no keys to decrypt it.':
    '미디어가 암호화되어 있으며 암호를 해독할 키가 없습니다.',
};
